import { graph, paramsWithRole } from '@/api/graph';
import { wrapGraphQLError } from '@/api/utils';

// region graphql
graph.fragment({
  showDocumentBasic: `on ShowDocument {
    id
    showId
    showRoleId
    title
    ...showDocumentUrls
    position
    createdAt
    updatedAt
  }`,
  showDocumentUrls: `on ShowDocument {
    urls { style url expiration fileName }
  }`,
});

const retrieveUrlQuery = graph.query(`($showDocumentId: ID!) {
  showDocument(showDocumentId: $showDocumentId) {
    id
    ...showDocumentUrls
  }
}`);

const retrieveQuery = graph.query(`($showDocumentId: ID!) {
  showDocument(showDocumentId: $showDocumentId) {
    ...showDocumentBasic
  }
}`);

const createMutation = graph.mutate(`($input: CreateShowDocumentInput!) {
  createShowDocument(input: $input) {
    showDocument { ...showDocumentBasic }
  }
}`);

const updateMutation = graph.mutate(`($input: UpdateShowDocumentInput!) {
  updateShowDocument(input: $input) {
    showDocument { ...showDocumentBasic }
  }
}`);

const uploadMutation = graph.mutate(`($input: UploadShowDocumentInput!) {
  uploadShowDocument(input: $input) {
    showDocument {
     id
     ...showDocumentUrls
    }
    presignedPost { ...presignedPost }
  }
}`);

const reorderMutation = graph.mutate(`($input: ReorderShowDocumentInput!) {
  reorderShowDocument(input: $input) {
    showDocument { id position }
    updatedShowDocuments { id position }
  }
}`);

const deleteMutation = graph.mutate(`($input: DeleteShowDocumentInput!) {
  deleteShowDocument(input: $input) { showDocumentId }
}`);

// endregion
export function retrieve({ showDocumentId, ...withOptions } = {}) {
  return retrieveQuery(paramsWithRole({ showDocumentId, ...withOptions }))
    .catch(wrapGraphQLError)
    .then((data) => data.showDocument);
}

export function retrieveUrls({ showDocumentId } = {}) {
  return retrieveUrlQuery({ showDocumentId })
    .catch(wrapGraphQLError)
    .then((data) => data.showDocument);
}

export function create({ showDocument }) {
  return createMutation(paramsWithRole({ input: showDocument }))
    .catch(wrapGraphQLError)
    .then(result => result.createShowDocument);
}

export function update({ showDocumentId, updates, options = {} }) {
  return updateMutation(paramsWithRole({ input: { showDocumentId, ...updates }, ...options }))
    .catch(wrapGraphQLError)
    .then(result => result.updateShowDocument);
}

export function upload({ showDocumentId, ...options }) {
  return uploadMutation({ input: { showDocumentId, ...options } })
    .catch(wrapGraphQLError)
    .then(result => result.uploadShowDocument);
}

export function reorder({ showDocumentId, position, relatedShowDocumentId = null }) {
  return reorderMutation({ input: { showDocumentId, position, relatedShowDocumentId } })
    .catch(wrapGraphQLError)
    .then(result => result.reorderShowDocument);
}

function _delete({ showDocumentId }) {
  return deleteMutation({ input: { showDocumentId } })
    .catch(wrapGraphQLError)
    .then(result => result.deleteShowDocument);
}

export { _delete as delete };
